import { AudienceCreatePresenter } from '@/components/audiences/audience-create.presenter';
import { useCreateAudiencePage } from '@/components/audiences/use-create-audience-page';

export default function CreateAudiencePage() {
  const audience = useCreateAudiencePage();

  return <AudienceCreatePresenter {...audience} />;
}
